import api from '@/services/api';

/**
 * Lädt eine Procurat-CSV und liefert Preview + fileId zurück.
 * @param {File} file
 * @returns {Promise<{fileId:string,stats:Object,rows:Array}>}
 */
export function uploadProcuratCsv(file) {
  const form = new FormData();
  form.append('file', file);
  return api.post('/admin/students/procurat/upload', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r.data);
}

/**
 * Verarbeitet selektierte Zeilen anhand der zuvor hochgeladenen Datei.
 * @param {string} fileId
 * @param {string[]} selectedKeys
 * @returns {Promise<Object>}
 */
export function applyProcurat(fileId, selectedKeys) {
  return api.post('/admin/students/procurat/apply', { fileId, selectedKeys }).then(r => r.data);
}

export default {
  uploadProcuratCsv,
  applyProcurat,
};
